<template lang="pug">
    v-text-field(v-bind="textFieldProps" v-model="rut" :mask="mixRUTInputMask" :single-line="showLabels" :outline="showLabels" :rules="[mixRUTRules.validRUT]" ref="rut")
        div.formLabel(slot="prepend" v-if="showLabels") {{textFieldProps.label}}

</template>

<script>
import RUTUtils from '@/mixins/RUTUtils'
export default {
    name: 'rut-input',
    data: function(){
        return {
            rut: ''
        }
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        textFieldProps: {
            type: Object,
            default: function() {
                return {
                    label: 'RUT',
                }
            },
        },
        showLabels: {
            type: Boolean,
            default: () => true
        }
    },
    watch: {
        rut: function(newVal) {
            this.mixRUTInputHandler(newVal)
            this.$emit('input', newVal)
            this.$emit('valid', this.$refs.rut.validate())
        },
    },
    mixins: [RUTUtils],
    updated: function(){
        this.rut = this.value
    }
}
</script>

<style lang="scss">
.formLabel{    
        font-weight: bold;
        min-width: 150px;
        max-width: 150px;
        font-size:20px;
    }
</style>
